module.exports = __webpack_public_path__ + "static/media/06. Devendra Darbar-ink.1e2e7244.jpeg";